import { checkScriptIsLoaded } from './script-utils.esm.js';

var googleApiUrl = function (conf) {
    var _a;
    var baseUrl = conf.baseUrl, accessToken = conf.accessToken, mapId = conf.mapId, locale = conf.locale;
    var language;
    var region;
    if (locale) {
        // eslint-disable-next-line no-useless-escape
        _a = /^([a-z]{2})((\-|\_)([A-Z]{2}))?$/.exec(locale) || [], language = _a[1], region = _a[4];
    }
    var params = {
        callback: 'mapsCallback',
        key: accessToken,
        map_ids: mapId,
        channel: null,
        language: "".concat(language === null || language === void 0 ? void 0 : language.toLowerCase()).concat(region ? "-".concat(region.toUpperCase()) : ''),
        region: region === null || region === void 0 ? void 0 : region.toUpperCase()
    };
    var paramStr = Object.keys(params)
        .filter(function (k) { return params[k] !== undefined; })
        .map(function (k) { return "".concat(k, "=").concat(params[k]); })
        .join('&');
    return "".concat(baseUrl).concat(baseUrl.indexOf('?') > 0 ? '&' : '?').concat(paramStr);
};
var removeGoogleMapScript = function () {
    // Remove google from BOM (window object)
    window.google = undefined;
    // Remove google map scripts from DOM
    Array.prototype.slice
        .call(document.getElementsByTagName('script'))
        .filter(function (script) { return typeof script.src === 'string' && script.src.includes('maps.googleapis'); })
        .forEach(function (script) { return script.remove(); });
};
var checkApiIsLoaded = function () { return window.google; };
var checkApiIsLoading = function () { return window.googleLoading; };
/**
 * Load google-maps api.
 *
 * @param reloadSDK force to reload sdk if already loaded. Useful when you want to change the locale that has been loaded.
 * @param conf the api configuration to used
 * @param resolveImmediately don't way for google-maps callback to revolve this call.
 * @returns returns true if the api was loaded through this call, and false if the api was already loaded and not force to be reloaded.
 */
var initGoogleMapsApi = function (reloadSDK, conf, resolveImmediately) {
    return new Promise(function (resolve) {
        if (checkApiIsLoaded() && !reloadSDK) {
            resolve(false);
        }
        else if (checkApiIsLoading()) {
            checkScriptIsLoaded('google', checkApiIsLoaded, checkApiIsLoading, { delay: 200, maxRetries: 100 }).then(function () {
                return resolve(false);
            });
        }
        else {
            window.googleLoading = true;
            if (resolveImmediately)
                window.mapsCallback = function () { return 0; };
            else
                window.mapsCallback = function () {
                    window.googleLoading = undefined;
                    resolve(true);
                };
            if (checkApiIsLoaded()) {
                removeGoogleMapScript();
            }
            var url = googleApiUrl(conf);
            var script = document.createElement('script');
            var head = document.querySelector('head');
            script.src = url;
            head === null || head === void 0 ? void 0 : head.appendChild(script);
            if (resolveImmediately) {
                resolve(true);
            }
        }
    });
};

export { initGoogleMapsApi };
